exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required[data-v-068b6362]::before {\n  content: \"*\";\n  position: absolute;\n  left: -10px;\n  top: 20%;\n  color: #f56c6c;\n}", ""]);

// exports
